import Component from '~/components/component';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import {PageEvent} from '~/pages/page.js';
import {MenuEvent} from '~/components/menu/menu.js';
import {Power2} from "gsap";
import States from '../../helpers/states';

export default class Header extends Component {
    constructor(...args) {
        super(...args);
        this.dom.jsTextualContent = this.dom.component.querySelector('.js-textual-content')
        this._retrieveDOM();        
    }

    _animateNoLoopVideoPoster(noLoopVideoComponent){
        TweenLite.to(noLoopVideoComponent.poster, 1.2, {
            opacity: 1,
            ease: Power3.easeOut
        })
    }


    _retrieveDOM() {
        this._mask = this.dom.component.querySelector( '[data-scrolling-mask]' );
        this.dom.scroller = this.dom.component.querySelector('.js-scroller');
    }

    init() {

        /** Check if we need scrolling introduction scene **/
        if( this.dom.component.classList.contains( 'fixed-bg' ) )
            this._initScrollingScene();

    }

    bind() {
        super.bind();

        if( this.dom.scroller ) {
            this.dom.scroller.addEventListener('click', () => {
                var headerHeight = this.dom.component.getBoundingClientRect().height;
                //add 1px to offset to enable white background on menu
                TweenMax.to( window, 1, { scrollTo: {y: headerHeight + 1, autoKill: false} , ease: Cubic.easeOut } );
            });
        }

    }

    _initScrollingScene() {
        // Create Tweenmax Animation
        let tween = new TimelineMax();
        tween.to( this._mask, 1, { opacity: 0.7, ease: Cubic.easeInOut });

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.component,
            tweenChanges: true, // smooth effect
            offset: window.innerHeight / 3,
            duration: "110%"
        });
        scene.setTween( tween );

        this.emit( PageEvent.ADD_SCENE, scene );
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/header/header.js